import React from "react";
import {getCharacterDatabaseData} from "../includes/axios/getCharacterDatabaseData.js";
import ComicAlphabet from "../alphabet/comicAlphabet.js";
import ComicDatabaseDisplay from "../comicDatabaseDisplay/comicDatabaseDisplay.js";
import "../../css/sharedStyles.css";
import ComicPagination from "../pagination/ComicPagination.js";

var ComicDatabaseLayout = class ComicDatabaseLayout extends React.Component{
    
    constructor(props) {
        super(props);
      }  



      componentDidMount(){
        this.props.changeCurrentPage("comicDatabase")
      }//end componentDidMount() 
    
    
    
    
    
    
    
    render() {
      const inlineStyle = {
        
      }
      
      return (
        <div className = "content_box_square">
            <ComicAlphabet 
                changeComicDatabase = {this.props.changeComicDatabase}
                comicDatabase = {this.props.comicDatabase}
                showComicDatabase = {this.props.showComicDatabase}
                pagination = {this.props.pagination}
                changeComicPaginationPage = {this.props.changeComicPaginationPage}
                changeComicPaginationOffset= {this.props.changeComicPaginationOffset}
                changeComicLetter = {this.props.changeComicLetter}
            />
            <ComicPagination 
                changeComicDatabase = {this.props.changeComicDatabase}
                comicDatabase = {this.props.comicDatabase}
                showComicDatabase = {this.props.showComicDatabase}
                pagination = {this.props.pagination}
                changeComicPaginationPage = {this.props.changeComicPaginationPage}
                changeComicPaginationOffset= {this.props.changeComicPaginationOffset}
                changeComicLetter = {this.props.changeComicLetter}
            />



            <ComicDatabaseDisplay 
                comicDatabase = {this.props.comicDatabase}
                changeMainComic = {this.props.changeMainComic } 
            />
        </div>
      );
    }
  }

  export default ComicDatabaseLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/comicDatabaseLayout.js